import React from "react";
import { Link, useLocation, useSearchParams } from "react-router-dom";
import { Lock, ArrowLeft } from "lucide-react";
import PublicLayout from "@/layouts/PublicLayout";

/**
 * Phase-2 CTA stub. The CTA on Service Detail persists a real draft order,
 * then routes here. Phase-3's payments/booking phase will replace this shell
 * with the actual booking + escrow-checkout flow.
 */
export default function CheckoutPreviewPage() {
  const [sp] = useSearchParams();
  const { state } = useLocation();
  const draftId = sp.get("draft");

  return (
    <PublicLayout>
      <div className="mx-auto max-w-3xl px-6 py-16" data-testid="checkout-preview">
        <div className="rounded-2xl border border-slate-200 bg-white p-8 md:p-10 text-center">
          <div className="mx-auto h-12 w-12 rounded-2xl bg-[#165a71]/10 text-[#165a71] flex items-center justify-center">
            <Lock className="h-5 w-5" />
          </div>
          <h1 className="mt-4 font-display text-2xl md:text-3xl font-semibold text-[#071b22]">
            Your selection is saved.
          </h1>
          <p className="mt-3 text-[#252A34]/75 leading-relaxed">
            We've persisted your package + add-ons as draft <code className="bg-slate-100 rounded px-1.5 py-0.5 text-xs">{draftId}</code>.
            The full booking + escrow-protected checkout arrives in <b>Phase 3 (Payments)</b>.
          </p>
          {state?.service && (
            <div className="mt-6 rounded-xl bg-slate-50 border border-slate-200 p-4 text-left">
              <div className="font-medium text-[#071b22]">{state.service.title}</div>
              <div className="text-xs text-[#252A34]/60 mt-1">You'll finish this booking from your dashboard next phase.</div>
            </div>
          )}
          <Link to="/services" className="mt-8 inline-flex items-center gap-2 text-[#165a71] font-medium hover:underline" data-testid="checkout-back">
            <ArrowLeft className="h-4 w-4" /> Back to services
          </Link>
        </div>
      </div>
    </PublicLayout>
  );
}
